module.exports = __webpack_public_path__ + "static/media/ipitch.39aa1b27.svg";